export default "__VITE_ASSET__CHWO10QH__"